// extracted by mini-css-extract-plugin
export default {"li":"ListItem_li__D541j","div":"ListItem_div__OeUbM","p":"ListItem_p__aif8W"};